import { defineComponent as _defineComponent } from 'vue'
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcCheckboxLarge from '@/views/Automation/CampaignCreatorV2/components/CcCheckbox/CcCheckboxLarge.ts.vue';
import CcRadioGroupText from '@/views/Automation/CampaignCreatorV2/components/CcRadioGroup/CcRadioGroupText.ts.vue';
import useAdStore from '@/views/Automation/CampaignCreatorV2/store/Ad';
import { CardLayer } from '@/views/Automation/CampaignCreatorV2/types';
import Treeselect from '@riophae/vue-treeselect';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdSetup.ts',
  setup(__props) {

const adStore = useAdStore();
const { getInternalMetadata } = storeToRefs(adStore);

const adSetupOptions = [
  { id: 'CREATE_AD', label: 'Create Ad' },
  { id: 'EXISTING_POST', label: 'Use existing post', isDisabled: true },
  { id: 'CREATIVE_HUB_MOCKUP', label: 'Use Creative Hub mockup', isDisabled: true },
];

const creativeSourceOptions = [
  {
    text: 'Manual placements',
    value: 'MANUAL_PLACEMENTS',
    disabled: false,
    info: 'Manually upload images or videos.',
    id: 'MANUAL_PLACEMENTS',
  },
  {
    text: 'Catalog Plus',
    value: 'CATALOG',
    disabled: true,
    info: "Automatically use media from your catalog. We'll show each person the catalog items they're most likely to engage with.",
    requestFeature: true,
    id: 'CATALOG',
  },
];

const adFormatOptions = [
  {
    text: 'Single image or video',
    value: 'SINGLE_IMAGE',
    disabled: false,
    info: 'One image or video, or a slideshow with multiple images',
    id: 'SINGLE_IMAGE',
  },
  {
    text: 'Carousel',
    value: 'CAROUSEL',
    disabled: true,
    info: 'Two or more scrollable images or videos',
    requestFeature: true,
    id: 'CAROUSEL',
  },
  {
    text: 'Collection',
    value: 'COLLECTION',
    disabled: true,
    info: 'Group of items that opens into a fullscreen mobile experience',
    requestFeature: true,
    id: 'COLLECTION',
  },
];

const adSetup = computed(() => getInternalMetadata.value('ad_setup'));

const creativeSource = computed(() => getInternalMetadata.value('creative_source'));

const adFormat = computed(() => getInternalMetadata.value('ad_format'));

const multiAdvertiserAds = computed(() => getInternalMetadata.value('multi_advertiser_ads'));

const isAdSetupCreateAd = computed(() => adSetup.value === 'CREATE_AD');

function onAdSetupChange(value: { id: string }) {
  adStore.updateInternalMetadata('ad_setup', value.id);
}

function onCreativeSourceChange(value: string) {
  adStore.updateInternalMetadata('creative_source', value);
}

function onAdFormatChange(value: string) {
  adStore.updateInternalMetadata('ad_format', value);
}

function onMultiAdvertiserAdsChange(value: boolean) {
  adStore.updateInternalMetadata('multi_advertiser_ads', value);
}

return { __sfc: true,adStore, getInternalMetadata, adSetupOptions, creativeSourceOptions, adFormatOptions, adSetup, creativeSource, adFormat, multiAdvertiserAds, isAdSetupCreateAd, onAdSetupChange, onCreativeSourceChange, onAdFormatChange, onMultiAdvertiserAdsChange, CcCard, CcCardItem, CcCheckboxLarge, CcRadioGroupText, CardLayer, Treeselect }
}

})